//Get data for language modal
var a = '[{"label": "NorthAmerica","value": "NorthAmerica","countries": [{"label": "USA","value": "USA","url": "https://www.signode.com"}]}]';
const locales = JSON.parse(a.replace(/&quot;/g, '"'));

$('.js-culture-switcher').change(function () {
    $('#js-change-site').attr('href', this.value);
});